// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import LoadingComponent from './components/loading'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from './store'

import 'swiper/css/swiper.min.css'
import '../static/css/fonts.css'
import 'wowjs/css/libs/animate.css'

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(ElementUI);
Vue.component('loading-component', LoadingComponent);

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  /* 路由发生变化修改页面meta */
  // console.log(to);console.log(from);console.log(next);
  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let tagsmeta = document.getElementsByTagName('meta');
    let hasDescriptionOrKeywords = false;
    for(var i=0; i<tagsmeta.length; i++){
      if(tagsmeta[i].getAttribute('name') == 'description'){
        tagsmeta[i].setAttribute('content',to.meta.content);
        hasDescriptionOrKeywords = true;
      }
      if(tagsmeta[i].getAttribute('name') == 'keywords'){
        tagsmeta[i].setAttribute('content',to.meta.keywords);
        hasDescriptionOrKeywords = true;
      }
    }
    if(!hasDescriptionOrKeywords){
      let meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = to.meta.content;
      head[0].appendChild(meta);
      let meta2 = document.createElement('meta');
      meta2.name = 'keywords';
      meta2.content = to.meta.keywords;
      head[0].appendChild(meta2);
    }


  }
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js